/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 02.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import DataView from "./DataView";
import t from "../../../../trans";
import DataProvider from "../../../../DataProvider";
import DataItem from "../../../../components/DataItem";
import BasePageComponent from "../BasePageComponent";


class ViewRecord extends BasePageComponent {
    static propTypes = {
        /**
         * Data provider object
         */
        dataProvider: PropTypes.instanceOf(DataProvider).isRequired
    };

    static defaultProps = {};

    render() {
        let dataProvider = this.props.dataProvider;
        return (
            <form className="form-horizontal">
                <div className="row">
                    <DataView dataProvider={dataProvider} />
                </div>
                <div className="hr-line-dashed"/>
                <div className="form-group">
                    <div className="col-md-6">
                        <DataItem dataProvider={dataProvider} field="created" title={t("Created")} type="span"/>{" "}
                        <DataItem dataProvider={dataProvider} field="createdBy" title={t("by")} type="span"/>
                    </div>
                    <div className="col-md-6">
                        <DataItem dataProvider={dataProvider} field="lastModified" title={t("Last changed")} type="span"/>{" "}
                        <DataItem dataProvider={dataProvider} field="lastModifiedBy" title={t("by")} type="span"/>
                    </div>
                </div>
            </form>
        );
    }
}

export default ViewRecord;
